import { useCollection } from '../../../firebase/hooks/useCollection';
import { Workstream } from '../types';
import { useWorkspaceContext } from '../context/WorkspaceContext';
import { useWorkstreams as useFirebaseWorkstreams } from '../../../firebase/hooks/useWorkstreams';

export const useWorkstreams = () => {
  const { workspaceId } = useWorkspaceContext();
  const { data: workstreams = [], loading, error } = useCollection<Workstream>(
    `workspaces/${workspaceId}/workstreams`,
    [],
    { idField: 'id' }
  );
  const { addWorkstream, updateWorkstream, deleteWorkstream, updateWorkstreamMilestones } = useFirebaseWorkstreams(workspaceId);

  const status = loading ? 'loading' : error ? 'error' : 'success';

  return {
    workstreams,
    status,
    addWorkstream,
    updateWorkstream,
    deleteWorkstream,
    updateWorkstreamMilestones
  };
};